import {
  apiRequest,
  verifikasiTunjanganKhususList,
  verifikasiTunjanganKhususGenerate,
  verifikasiTunjanganKhususVerifikasi,
  verifikasiTunjanganKhususCekVerifikasi,
  openVerification,
  exportExcel,
  masterWorkUnit,
  listAtasan,
  detailBobot,
} from "../../../../../services/adapters/kepegawaian/verifikasiTunjanganKhususService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      verifikasiTunjanganKhususList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchAtasan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listAtasan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchGenerate = async (query) => {
    return await apiRequest(
      "get",
      verifikasiTunjanganKhususGenerate,
      {
        params: query,
      },
      true
    );
  };

  fetchVerifikasi = async (query) => {
    return await apiRequest(
      "get",
      verifikasiTunjanganKhususVerifikasi,
      {
        params: query,
      },
      true
    );
  };

  cekVerifikasi = async (query) => {
    return await apiRequest(
      "get",
      verifikasiTunjanganKhususCekVerifikasi,
      {
        params: query,
      },
      true
    );
  };
  openVerification = async (query) => {
    return await apiRequest("post", openVerification, {
      body: query
    }, true)
  }
  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };

  fetchBobot = async (query) => {
    return await apiRequest(
      "get",
      detailBobot,
      {
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
